// Copyright © 2024 Broadcom Inc. and its subsidiaries. All Rights Reserved.
import { get } from 'lodash';

const styles = ({ color, fontSize, margin, padding, typography }) => ({
  details: {
    margin: 36,
    padding: get(padding, 'p36'),
    backgroundColor: color.uiBackground,
    marginTop: 0,
  },
  categoryField: {
    display: 'inline-block',
    marginBottom: '0 !important',
    marginLeft: 8,
    marginRight: 8,
    marginTop: '0 !important',
    width: '100%',
  },
  templateSubtitleContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
  },
  pageTitle: {
    color: get(color, 'pageTitle'),
    fontFamily: get(typography, 'pageTitle'),
    fontSize: get(fontSize, 'pageTitle'),
    marginTop: 6,
  },
  helpIconContainer: {
    display: 'flex',
  },
  helpIcon: {
    fontSize: 20,
    margin: get(margin, 'm2'),
    verticalAlign: 'middle',
    cursor: 'pointer',
    color: `${get(color, 'link')} !important`,
  },
});

export default styles;
